import React, { useEffect, useRef } from "react";
import QRCodeStyling from "qr-code-styling";

type Props = {
  link: string;
  size?: number;
  color?: string;
  bgColor?: string;
};

const VQrCode: React.FC<Props> = ({
  link,
  size = 100,
  color = "#4bafb1",
  bgColor = "transparent",
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const qrRef = useRef<QRCodeStyling | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const qr = new QRCodeStyling({
      type: "svg",
      data: link,
      width: size,
      height: size,
      dotsOptions: {
        color,
        type: "rounded",
      },
      backgroundOptions: {
        color: bgColor,
      },
    });
    qrRef.current = qr;
    qr.append(containerRef.current);
    return () => {
      qrRef.current = null;
    };
  }, []);

  useEffect(() => {
    qrRef.current?.update({
      data: link,
      width: size,
      height: size,
      dotsOptions: { color },
      backgroundOptions: { color: bgColor },
    });
  }, [link, size, color, bgColor]);

  return (
    <div
      ref={containerRef}
      style={{ width: size, height: size }}
      aria-hidden
    />
  );
};

export default VQrCode;
